import store from '@/stores/'
import UNIQUE from '@/common/unique'

const defaultValue = 'input'
const langValue = function () {
  const obj = Object.assign({}, store.state.setting.lang.langValue)
  Object.keys(obj).forEach(function (x) {
    obj[x] = defaultValue
  })
  return obj
}

export default {
  id: 'input',
  name: 'input',
  type: 'action',
  moduleName: 'editor_module_input',
  dataSet: {
    mods: 'input',
    column: [
      {
        columnId: UNIQUE.mid(),
        type: 'input',
        value: {
          label: ''
        }
      }
    ]
  },
  setting: {
    layout: {
      options: [
        'fullsize',
        'background',
        'border',
        'text',
        'padding'
      ]
    },
    action: {
      name: 'input',
      isRequired: true,
      label: langValue(),
      labelValue: defaultValue,
      labelFontSize: 'default',
      valueFontSize: 'default'
    },
    detail: null
  }
}
